import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { TableCell as MuiTableCell } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { GRAY } from "../../constants/colors/hex";
var useStyles = makeStyles({
  root: {
    borderBottom: "1px solid ".concat(GRAY[18]),
    backgroundColor: 'transparent',
    padding: '16px !important' // TODO: remove !important after legacy.min.css is removed. !important is needed here to override an overly aggressive CSS rule in legacy.min.css
  },
  head: {
    fontWeight: 600
  }
});
export function TableCell(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(MuiTableCell, _extends({
    classes: classes
  }, props));
}